import { render } from "./UsageStatusSectionErrorCmp.vue?vue&type=template&id=640da02f&scoped=true"
import script from "./UsageStatusSectionErrorCmp.vue?vue&type=script&lang=js"
export * from "./UsageStatusSectionErrorCmp.vue?vue&type=script&lang=js"

import "../css/UsageStatusSectionError.css?vue&type=style&index=0&id=640da02f&scoped=true&lang=css"
import "./UsageStatusSectionErrorCmp.vue?vue&type=style&index=1&id=640da02f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640da02f"]])

export default __exports__